import React, { useState, useEffect } from "react";
import { CardBody, Card, Row, Col, Table, Button, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { PayrollClient } from "services";
import { Trans } from "react-i18next";
import { NotificationManager } from "react-notifications";
import MainForm from "./shiftform"
import ShiftsList from "./ShiftsList";
import { Page } from "components/common";


const ShiftsManagementList = ({ t, ...props }) => {

  const payrollClient = PayrollClient();

  const [load, setLoad] = useState([]);

  var intial_state = {
    name: "",
    time_from: "",
    time_to: "",
    time_from2: null,
    time_to2: null,
    date_from: "",
    date_to: ""
  }

  const [shiftForm, setShiftForm] = useState(intial_state)

  const addItem = (validateForm, form_) => {

    const errors = validateForm(form_);

    if (errors.length > 0) {
      NotificationManager.error(errors[0]);
      return;
    }

    const shiftFormHolder = Object.entries(shiftForm).reduce((a, [k, v]) => (v ? (a[k] = v, a) : a), {})

    payrollClient
      .post('shifts', {
        ...shiftFormHolder
      })
      .then(({ data }) => {
        NotificationManager.success(t("Saved successfully"));
        setShiftForm(intial_state)
        setLoad(!load)
      })
      .catch((err) => {
        NotificationManager.error(t('Error while adding new shift'));
      });
  }

  const deleteItem = (id) => {

    payrollClient
      .delete(`shifts/${id}`)
      .then(({ data }) => {
        setLoad(!load)
        NotificationManager.success(t("Deleted successfully"));
      })
      .catch((err) => {
        NotificationManager.error(t('Error while deleting shift'));
      });
  }
  return (
    <Page title={t('Shifts')} showTitle={true} titleClass="h4">
      <CardBody>
        <div className="border p-3">
          <h4><Trans> Add New Shift </Trans></h4>

          {/* <Form className="form mt-3"> */}
          <MainForm shiftForm={shiftForm} setShiftForm={setShiftForm} type="Add" action={addItem} t={t} />
          {/* </Form> */}

        </div>
        <div className="sep my-4">
          <hr />
        </div>
        <div className="border p-3">
          <ShiftsList deleteItem={deleteItem} load={load} {...props}></ShiftsList>
        </div>

      </CardBody>
    </Page>
  )
};

export default ShiftsManagementList;